"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var QAFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_QAFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.782 1.092C16 1.52 16 2.08 16 3.2v1.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874c-.237.121-.516.175-.908.199v2.624c0 .364-.396.533-.607.26L12 9.073v-.912c0-.527 0-.981-.03-1.356-.033-.395-.104-.789-.297-1.167a3 3 0 0 0-1.311-1.311c-.378-.193-.772-.264-1.167-.296C8.82 4 8.365 4 7.839 4H5v-.8c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C6.52 0 7.08 0 8.2 0h4.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C1.52 5 2.08 5 3.2 5h4.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C11 6.52 11 7.08 11 8.2v1.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C9.48 13 8.92 13 7.8 13H4.835l-2.228 2.865c-.21.273-.607.104-.607-.26v-2.624c-.392-.024-.67-.078-.908-.199a2 2 0 0 1-.874-.874C0 11.48 0 10.92 0 9.8V8.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_QAFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = QAFill;
exports["default"] = _default;